import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { setCloseInvalidRowsModal, setOpenInvoiceUploadModal } from "../../redux/features/invoice/invoiceSlice";

interface InvalidRowsModalProps {
  show: boolean;
  onHide: () => void;
  invalidRows: {
    row: number;
    errors: { reason: string; key: string; value: any; order_number: any, article_code: any }[];
  }[];
}

const InvalidRowsModal: React.FC<InvalidRowsModalProps> = ({ show, onHide, invalidRows }) => {
  const dispatch = useDispatch();

  const handleReloadFile = () => {
    dispatch(setCloseInvalidRowsModal());
    dispatch(setOpenInvoiceUploadModal({}));
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Invalid lines</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: "60vh", overflowY: "auto" }}>
        {invalidRows.map((item, idx) => (
          <div key={idx} className="mb-4 border-bottom pb-3">
            <strong>Riga {item.row}</strong>
            <div className="mt-2 ps-3">
              {item.errors && item.errors.length > 0 ? (
                item.errors.map((err, i) => (
                  <div key={i} className="mb-4 p-3 border rounded bg-light">
                    <p className="mb-2">
                      <span className="badge bg-primary fs-6">Order Number: {err.order_number}</span>
                    </p>
                    <p className="mb-2">
                      <span className="badge bg-secondary fs-6">Caleffi Article Code: {err.article_code}</span>
                    </p>

                    <p className="mb-1 fw-bold">Error detected:</p>

                    <p className="mb-0">
                      <span className="fw-bold text-danger">{err.key}:</span>
                      <span className="ms-1">{String(err.value)}</span>
                      <br />
                      <small className="text-muted fst-italic">Reason: {err.reason}</small>
                    </p>
                  </div>
                ))
              ) : (
                <em>No field specified</em>
              )}
            </div>
          </div>
        ))}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleReloadFile}>
          Reload Document
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default InvalidRowsModal;